<template>
  <!-- Modal -->
  <div class="modal fade" data-backdrop="static" id="loginModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Login</h5>
          <button type="button" class="close" @click="cancelModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">

          <form>
            <div class="form-group">
              <label for="username" class="col-form-label">Username:</label>
              <input type="text" class="form-control" id="username" ref="username" autocomplete/>
            </div>
              <div class="form-group">
                <label for="password" class="col-form-label">Password:</label>
                <input type="password" class="form-control" id="password" ref="password" autocomplete />
              </div>

          </form>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="cancelModal">Cancel</button>
          <button type="button" class="btn btn-primary" @click="login">Login</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import $ from 'jquery'

export default {
  name: 'LoginModal',
  props: ['collName', 'showLoginModal'],
  watch: {
    showLoginModal: function(newVal) {
      if (newVal) {
        $('#loginModal').modal('show')
      } else {
        $('#loginModal').modal('hide')
      }
      this.$refs.username.value = null
      this.$refs.password.value = null
    }
  },
  methods: {
    cancelModal: function(){
      this.$emit("cancelLoginModal")
    },
    login: function(){
      this.$emit("submitLoginModal", {
        username: this.$refs.username.value,
        password: this.$refs.password.value
      })
    }
  }
}
</script>
